<ng-container *ngTemplateOutlet="matchMedia('(min-width: 1200px)') ? navItems : sideMenu">
</ng-container>

<ng-template #sideMenu>
  <unh-side-menu [isOpen]="isOpen" [position]="position" [withWarning]="hasWarning">
    <unh-side-menu-content>
      <unh-nav-items-container [navItemList]="navItemList">
      </unh-nav-items-container>

      <unh-social-menu [isVisibleSocialMenu]="true"></unh-social-menu>

    </unh-side-menu-content>
  </unh-side-menu>
</ng-template>

<ng-template #navItems>
  <unh-nav-items-container [navItemList]="navItemList">
  </unh-nav-items-container>
</ng-template>
